import React, { useEffect, useState, useMemo } from "react";
import MetaTags from "react-meta-tags";

import { Container } from "reactstrap";
import SearchDocPlace from "../../components/search/search";
import { ToastContainer } from "react-toastify";
import NewItemDocPlace from "./components/new/new";
//API CALL
import {
  getInputMethodList,
  deleteInputMethod,
} from "../../store/inputMethod/actions";
//END
import { useDispatch, useSelector } from "react-redux";
import Title from "../../components/title/title";
import { useNavigate } from "react-router-dom";
import LoadingComponent from "../../components/loading";
import Button from "@mui/material/Button";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import debounce from "lodash.debounce";
import JustifyBetween from "../../components/common/JustifyBetween";
import { BaseDataTable } from "../../components/common/BaseDataTable";
import CellActions from "../../components/common/CellActions";
import { colors } from "../../components/theme";

const InputMethodDocPlace = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [startPage] = useState(true);
  const [showNew, setShowNew] = React.useState(false);
  const [defaultData, setDefaultData] = React.useState("");
  const [inputMethodList, setInputMethodList] = React.useState([]);
  const [valueSearch, setValueSearch] = useState("");

  const { responseInputMethod, loading } = useSelector(
    (state) => ({
      responseInputMethod: state.InputMethod.responseInputMethod,
      loading: state.InputMethod.loadingInputMethod,
    })
  );

  const { responseInputMethodDelete, loadingInputMethodDelete } = useSelector(
    (state) => ({
      responseInputMethodDelete: state.InputMethod.responseInputMethodDelete,
      loadingInputMethodDelete: state.InputMethod.loadingInputMethodDelete,
    })
  );

  useEffect(() => {
    dispatch(getInputMethodList({ name: " " }, navigate));
  }, [startPage]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (responseInputMethod?.data.length > 0) {
      let i = [];
      responseInputMethod.data.forEach((item) => {
        i.push({
          id: item.id,
          name: item.content.Name,
          physicalName: item.content.PhysicalName,
          description: item.description,
          doctypeName: item.doctype.name,
          originId: item.originId,
          originTypeText: item.originType,
          originType: {
            value: item.originType,
            label: item.originType,
          },
          docType: {
            value: item.doctype.id,
            label: item.doctype.name,
          },
        });
      });
      setInputMethodList(i);
    }
  }, [responseInputMethod]);

  useEffect(() => {
    if (responseInputMethodDelete !== null) {
      dispatch(getInputMethodList({ name: " " }, navigate));
    }
  }, [responseInputMethodDelete]); // eslint-disable-line react-hooks/exhaustive-deps

  const searchFile = (filterSearch) => {
    setValueSearch(filterSearch);
  };

  const refresh = (item) => {
    dispatch(getInputMethodList({ name: " " }, navigate));
  };

  const closeModal = () => {
    setDefaultData(null);
    setShowNew(false);
  };

  const optionGrid = (value) => {
    if (value.action === "edit") {
      setDefaultData(value.row.row);
      setShowNew(true);
    } else {
      deleteItem(value.id);
    }
  };

  const deleteItem = (id) => {
    const MySwal = withReactContent(Swal);
    MySwal.fire({
      title: "Are you sure?",
      text: "",
      type: "warning",
      showCloseButton: true,
      showCancelButton: true,
    }).then((willDelete) => {
      if (willDelete.value) {
        dispatch(deleteInputMethod(id, navigate));
      }
    });
  };

  useEffect(() => {
    if (valueSearch) {
      dispatch(getInputMethodList({ name: valueSearch }, navigate));
    }
  }, [dispatch, navigate, valueSearch]);

  const debouncedResults = useMemo(() => {
    return debounce(searchFile, 300);
  }, []);

  useEffect(() => {
    return () => {
      debouncedResults.cancel();
    };
  });

  const selectOption = (op, id, row) => {
    optionSelect({ action: op, id: id, row: row });
  };

  const optionSelect = (event) => {
    optionGrid(event);
  };

  const columns = [
    {
      field: "name",
      flex: 1,
      headerClassName: "MuiTableHead-root",
      headerName: "Name",
    },
    {
      field: "physicalName",
      flex: 1,
      headerClassName: "MuiTableHead-root",
      headerName: "Physical Name",
    },
    {
      field: "description",
      flex: 1,
      headerClassName: "MuiTableHead-root",
      headerName: "Description",
    },
    {
      field: "doctypeName",
      flex: 1,
      headerClassName: "MuiTableHead-root",
      headerName: "DocType",
    },
    {
      field: "originId",
      flex: 1,
      headerClassName: "MuiTableHead-root",
      headerName: "Origin Id",
    },
    {
      field: "originTypeText",
      flex: 1,
      headerClassName: "MuiTableHead-root",
      headerName: "Origin Type",
    },
    {
      field: "options",
      headerName: "",
      sortable: false,
      headerClassName: "MuiTableHead-root",
      flex: 0.1,
      renderCell: (params) => (
        <CellActions
          onEdit={() => selectOption("edit", params.id, params)}
          onRemove={() => selectOption("remove", params.id, params)}
        />
      ),
    },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>DocPlace Input Method</title>
        </MetaTags>
        <Container fluid>
          <Title title={"Input Method"} viewActive={false} />
          <ToastContainer autoClose={3000} />
          <LoadingComponent
            show={loading || loadingInputMethodDelete}
            text={
              loading ? "Loading Input Method..." : "Deleting Input Method..."
            }
          />
          <JustifyBetween style={{ marginBottom: 20 }}>
            <Button
              onClick={() => {
                setShowNew(true);
              }}
              size="small"
              color="primary"
              style={{ backgroundColor: colors.blue }}
              variant="contained"
            >
              Add New
            </Button>
            <SearchDocPlace
              callSearch={debouncedResults.bind(this)}
              clear={() => {
                refresh("");
              }}
            />
          </JustifyBetween>
          <BaseDataTable
            data={inputMethodList || []}
            columns={columns}
            option={optionGrid.bind(this)}
          />
        </Container>
      </div>
      <NewItemDocPlace
        done={refresh.bind(0, this)}
        close={closeModal.bind(this)}
        default={defaultData}
        show={showNew}
      />
    </React.Fragment>
  );
};

export default InputMethodDocPlace;
